import React from "react";
import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { GLOBAL_TOAST_CONTAINER_ID } from "./utils/accessDenied";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
      {/* Mounted once for toasts raised outside the React tree, such as the
          403 handler in the axios response interceptors. */}
      <ToastContainer
        containerId={GLOBAL_TOAST_CONTAINER_ID}
        position="bottom-right"
        autoClose={5000}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
}

export default App;
